import { Auth } from 'aws-amplify';

const VODAFONE_TEST_USERS = [
  'vodafoneadminuser@techsmart.co.uk',
  'vodafonepartneruser@techsmart.co.uk',
];

export async function isVodafoneUser() {
  try {
    const session = await Auth.currentSession();
    const email = session?.idToken?.payload['email'];
    return VODAFONE_TEST_USERS.includes(email?.toLowerCase());
  } catch {
    return false;
  }
}
